<template>
  <div class="vg-content">
    <h3>暂无权限登录，原因：账号[{{ errorMessage }}]在电子出入证H5管理端未配置功能权限！</h3><br />
    <h5 class="text">点击<vg-button class="button" type="primary" @click="signOut">这里</vg-button>重新登录！</h5>
  </div>

</template>

<script >

import Cookies from "js-cookie";
import VgButton from "@/components/Commons/VgButton.vue";
import useAuthnStore from "@/store/authn";

export default {
  name: "LoginError",
  components: {VgButton},
  data() {
    return {
      errorMessage: null,
    }
  },
  created() {
    const authn = useAuthnStore();
    if (authn.getTitle) {
      this.errorMessage = authn.getTitle;
    }
  },
  methods: {
    signOut(){
      const authn = useAuthnStore();
      authn.logout();
      const tokenKey = 'Authorization';
      const loginType = 'loginType';
      const userName = 'userName';
      const userPhone = 'userPhone';
      const title = 'title';
      Cookies.remove(tokenKey)
      Cookies.remove(loginType)
      Cookies.remove(userName)
      Cookies.remove(userPhone)
      Cookies.remove(title)

      this.$router.push({
        path:'/',
        query: {
          type: 'guard'
        }
      });
    }
  }
}
</script>



<style scoped>
.vg-content {
  display:inline-block;
  text-align: center;
}
.text {
  display:inline-flex;line-height:40px;
}

</style>
